import React from 'react';
import { Section } from './ui/Section';
export function Benefits() {
  const benefits = [{
    icon: '⚡',
    title: 'Planificar una temporada completa en minutos',
    desc: 'Tendrás un arsenal de figuras y estructuras listas para usar, ahorrándote 5 horas de trabajo semanal.'
  }, {
    icon: '🎯',
    title: 'Seguridad absoluta frente a tus alumnos',
    desc: 'Entrarás a la sala con la autoridad de quien tiene un sistema validado, no una idea improvisada.'
  }, {
    icon: '💃',
    title: 'Aprender a enseñar Sensual con respeto',
    desc: 'Conocerás el protocolo exacto para guiar figuras de contacto sin generar incomodidad en el grupo.'
  }, {
    icon: '🔥',
    title: 'Fidelización real (Alumnos que no se van)',
    desc: 'Entenderás la psicología del alumno para que tus grupos se mantengan llenos mes tras mes.'
  }];
  return <Section variant="alt" data-id="element-67">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-68">
        🚀 LO QUE VAS A LOGRAR CON ESTE MANUAL
      </h2>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-69">
        {benefits.map((benefit, i) => <div key={i} className="bg-gradient-card border border-brand-borderGlow/20 rounded-2xl p-6 shadow-violet-glow hover:shadow-gold-glow transition-all hover:border-brand-gold/30" data-id="element-70">
            <div className="text-5xl mb-4" data-id="element-71">{benefit.icon}</div>
            <h3 className="font-heading text-lg font-bold text-brand-subtitle mb-3 tracking-wide" data-id="element-72">
              {benefit.title}
            </h3>
            <p className="font-body text-brand-text text-sm leading-relaxed" data-id="element-73">
              {benefit.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}